module.exports = __webpack_public_path__ + "img/bg2.f58c1651.png";